<template>
  <v-card flat>
    <v-card-title>
      Approved Bookings
      <v-spacer></v-spacer>
      <v-text-field
        append-icon="search"
        text="Search"
        single-line
        hide-details
        v-model="search"
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="columns"
      :items="approvedBookings"
      :search="search"
      :rows-per-page-items="[10,25,{'text':'All','value':-1}]"
      :disable-initial-sort="true"
      :loading="$loadingTrue"
    >
      <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <td class="fancy">{{ props.item.booking_ref_code}}</td>
        <td class="fancy">{{ props.item.booking_done_by}}</td>
        <td class="fancy">{{ props.item.booking_type}}</td>
        <td class="fancy">{{ formated_date(props.item.booking_check_in_date)}}</td>
        <td class="fancy">{{ formated_date(props.item.booking_check_out_date)}}</td>
        <td class="fancy">{{ props.item.guest_total}}</td>
        <td class="fancy">{{ props.item.booking_status}}</td>
        <td class="fancy">
          <button class="btn btn-info btn-sm" @click="openBooking(props.item.booking_public_id)">View Booking</button>
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  name: 'ApprovedBookings',
  data () {
    return {
      search: '',
      columns: [
        {
          text: 'Ref',
          name: 'booking_ref_code'
        },
        {
          text: 'Client Name',
          name: 'name'
        },
        {
          text: 'Number of Guests',
          name: 'guest_total'
        },
        {
          text: 'Status',
          name: 'booking_status'
        },
        {
          text: 'Action'
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>
